import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MessageService } from '../services/message.service';

@Injectable()
export class MyHttpInterceptor implements HttpInterceptor {
  constructor(private messageService: MessageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // console.log('Intercepted request', req.url);
    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse && event.status !== 200) {
            console.log('HttpResponse', event);
          }
        },
        (error: any) => {
          if (error instanceof HttpErrorResponse) {
            if (error.status === 0) {
              this.messageService.add('Fehler beim PDF Download. CORS Fehler.', 'error');
            } else {
              console.log('HttpErrorResponse', error);
              this.messageService.add(`Fehler beim PDF Download: ${error.message}`, 'error');
            }
          }
        },
      ),
    );
  }
}
